"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var MainItemWatcher = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MainItemWatcher, _super);
    function MainItemWatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainItemWatcher.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.reactToMainVideoIdChange(nextProps);
    };
    MainItemWatcher.prototype.reactToMainVideoIdChange = function (_a) {
        var mainItemIndex = _a.mainItemIndex, firstItemAtFrameIndex = _a.firstItemAtFrameIndex, inFrameItemsCount = _a.inFrameItemsCount, onFirstItemIndexUpdate = _a.onFirstItemIndexUpdate, onForceLastItemUpdate = _a.onForceLastItemUpdate;
        if (mainItemIndex === -1 || mainItemIndex === this.props.mainItemIndex) {
            return;
        }
        var isMainItemAtViewFrame = mainItemIndex >= firstItemAtFrameIndex &&
            mainItemIndex < firstItemAtFrameIndex + inFrameItemsCount;
        // just select main item if it is at view frame
        if (isMainItemAtViewFrame && inFrameItemsCount !== 1) {
            onForceLastItemUpdate((mainItemIndex - firstItemAtFrameIndex + 1) % inFrameItemsCount === 0);
            return;
        }
        // always make last if after to view frame
        if (mainItemIndex >= firstItemAtFrameIndex + inFrameItemsCount) {
            onFirstItemIndexUpdate(mainItemIndex - inFrameItemsCount + 1);
            if (inFrameItemsCount === 1) {
                return;
            }
            onForceLastItemUpdate(true);
            return;
        }
        // always make first if before to view frame
        onFirstItemIndexUpdate(mainItemIndex);
        onForceLastItemUpdate(false);
    };
    MainItemWatcher.prototype.render = function () {
        return null;
    };
    return MainItemWatcher;
}(react_1.default.Component));
exports.default = MainItemWatcher;
//# sourceMappingURL=main-item-watcher.js.map